import Phaser from "phaser";
import bg from "@/assets/game/office.webp";
import hero from "@/assets/game/man.png";
import authAxios from "@/plugins/authAxios";

export default class EndScene extends Phaser.Scene {
  constructor() {
    super("EndScene");
  }

  preload() {
    this.load.image("bg", bg);
    this.load.image("char", hero);
  }

  create(data) {
    const width = this.scale.width;
    this.score = data.score || 0;
    const allCorrect = this.score >= 100;

    // クイズ結果を送信
    authAxios
      .post("/api/quiz/score/", {
        score: this.score
      })
      .catch(err => {
        console.error("QuizScore API error", err);
      });

    this.add.image(400, 300, "bg");

    // 紙吹雪
    if (allCorrect) {
      const colors = [0xff6b6b, 0xfeca57, 0x48dbfb, 0x1dd1a1, 0xf368e0];

      // 四角形を生成(8x8）
      const graphics = this.make.graphics({ x: 0, y: 0, add: false });
      graphics.fillStyle(0xffffff);
      graphics.fillRect(0, 0, 8, 8);
      graphics.generateTexture("confettiRect", 8, 8);
      graphics.destroy();

      const emitter = this.add.particles(0, 0, "confettiRect", {
        x: { min: 0, max: width },
        y: 0,
        lifespan: 5000,
        gravityY: 300,
        speedY: { min: 100, max: 300 },
        speedX: { min: -150, max: 150 },
        scale: { start: 1, end: 0 },
        rotate: { min: 0, max: 360 },
        angle: { min: 0, max: 360 },
        quantity: 5,
        blendMode: "NORMAL"
      });

      // 個々の紙吹雪にランダム色を付ける
      emitter.onParticleEmit(particle => {
        particle.tint = Phaser.Math.RND.pick(colors);
      });

      // 放出停止
      this.time.delayedCall(3000, () => {
        emitter.stop();
      });
    }

    this.add.image(400, 400, "char").setScale(0.3);

    this.textBox = this.add
      .rectangle(400, 490, 760, 200, 0x000000, 0.6)
      .setStrokeStyle(2, 0xffffff);

    this.text = this.add.text(60, 405, "", {
      fontFamily: "'Noto Sans JP', sans-serif",
      fontSize: "20px",
      color: "#ffffff",
      wordWrap: { width: 680, useAdvancedWrap: true },
      lineSpacing: 8,
      padding: { top: 4 }
    });

    if (allCorrect) {
      this.text
        .setText(
          "素晴らしい！全問正解だ。しっかり理解できていて本当に頼もしい！"
        )
        .setAlign("center")
        .setOrigin(0.5)
        .setPosition(400, 460);

      this.add
        .text(
          400,
          520,
          "これであなたもエバンジェリスト！同僚や友人へ紹介しよう！",
          {
            fontFamily: "'Noto Sans JP', sans-serif",
            fontSize: "20px",
            color: "#ffffff"
          }
        )
        .setOrigin(0.5);
    } else {
      this.text.setText("残念だな、もう少し復習が必要だ。");
      // 最初からやり直すボタン
      this.restartText = this.add
        .text(400, 565, "[ 最初からやり直す ]", {
          fontFamily: "'Noto Sans JP', sans-serif",
          fontSize: "20px",
          color: "#ffffff",
          padding: { top: 4 }
        })
        .setOrigin(0.5)
        .setInteractive({ useHandCursor: true })
        .on("pointerdown", () => this.restartGame());
    }
  }

  restartGame() {
    this.cameras.main.fadeOut(800, 0, 0, 0);
    this.cameras.main.once("camerafadeoutcomplete", () => {
      this.scene.start("TitleScene");
    });
  }
}
